module.exports = __webpack_public_path__ + "static/media/logo_icon-only.41e5cd7c.png";